import { createApi } from '@reduxjs/toolkit/query/react'
import { queryParams } from '../../../Utils'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const bookingApiService = createApi({
    reducerPath: 'bookingApi',
    baseQuery: createNeighborhoodAwareBaseQuery('/booking/'),
    endpoints: (builder) => ({
        getBooking: builder.query({
            query: (args) => {
                let { id } = args

                if (id) {
                    return `get/${id}`
                }

                let query = queryParams(args)

                return `get${query}`
            },
            keepUnusedDataFor: 0
        }),
        getFinancialReport: builder.query({
            query: (params) => ({
                url: `report`,
                method: "GET",
                params
            }),
            keepUnusedDataFor: 0
        }),
        getMessages: builder.query({
            query: (data) => `get-messages/${data?.id}`,
            keepUnusedDataFor: 0
        })
    })
})


export const {
    useGetBookingQuery,
    useGetFinancialReportQuery,
    useGetMessagesQuery
} = bookingApiService

